export interface IFeature {
    enabled: boolean;
}
